import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineupCardComponent } from './lineup-card/lineup-card.component';
import { FlexLayoutModule} from '@angular/flex-layout';
import { LineupPremiereComponent } from './lineup-premiere/lineup-premiere.component';
import { PremiereCardMobileViewComponent } from './premiere-card-mobile-view/premiere-card-mobile-view.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserInvitationService } from 'src/app/core/services/user.invitation.service';
import { MixpanelModule } from 'src/app/shared/mix-pane.modul';


@NgModule({
  declarations: [
    LineupCardComponent,
    LineupPremiereComponent,
    PremiereCardMobileViewComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    SharedModule,
    MixpanelModule
  ],
  providers: [
    UserInvitationService
  ]
})
export class LineupModule { }
